import React, { useState } from "react";

const INIT = "init";
const START = "start";
const COMPLETE = "complete";

function OutOfStock({ variantId }) {
  const [state, setState] = useState(INIT);
  const [email, setEmail] = useState("");

  function notifyOnStockAvailable(e) {
    e.preventDefault();

    const id = variantId.replace("gid://shopify/ProductVariant/", "");

    const options = {
      method: "POST",
      headers: {
        accept: "application/json",
        revision: "2023-10-15",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: { type: "profile", attributes: { email: email } },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${id}`,
              },
            },
          },
        },
      }),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YaXfxA",
      options
    )
      .then((response) => response.text())
      .then(() => setState(COMPLETE))
      .catch((err) => console.error(err));
  }

  return (
    <div className="fflex gap-5 flex-wrap items-center w-full">
      {state === INIT && (
        <button
          className="primary_btn pp-no-hide w-full"
          onClick={() => setState(START)}
        >
          Email me when available
        </button>
      )}
      {state === START && (
        <form onSubmit={notifyOnStockAvailable} className="w-full space-y-3">
          <input
            placeholder="Email Address"
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="block text-xs sm:text-[15px] tracking-wider py-3 px-[35px] w-full md:w-[500px] lg:w-[80%]
            h-12 box-border rounded-full appearance-none sm:leading-7 disabled:bg-[#5f5f5f]
            border border-solid border-[#1f1f1f] text-center"
          />
          <button className="primary_btn pp-no-hide w-full" type="submit">
            Email me when available
          </button>
        </form>
      )}
      {state === COMPLETE && (
        <div className="w-full space-y-3">
          <p className="primary_btn pp-no-hide" onClick={() => setState(INIT)}>
            Thank you.
          </p>
          <p className="text-sm w-full font-semibold md:w-[500px] lg:w-[80%] px-2">
            We'll send you an email notification when this product is back in
            stock.`
          </p>
        </div>
      )}
    </div>
  );
}

export default React.memo(OutOfStock);
